import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SicotService } from '../sicot.service';
import { catchError, throwError } from 'rxjs';
import { RichiestePerStato } from '../types/CruscottoStatistiche';

@Injectable({
  providedIn: 'root'
})
export class CruscottoStatisticheService {

  API_ENDPOINT_COT_SERVICE = this.sicotService.API_ENDPOINT_COT_SERVICE;

  constructor(private http: HttpClient, private sicotService: SicotService) {  }

  getRichiesteTotali() {
    return this.http
      .get<number>(this.API_ENDPOINT_COT_SERVICE + '/richieste-totali')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getPazientiTotali() {
    return this.http
      .get<number>(this.API_ENDPOINT_COT_SERVICE + '/pazienti-totali-richieste')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getPazientiMaschiTotali() {
    return this.http
      .get<number>(this.API_ENDPOINT_COT_SERVICE + '/pazienti-maschi-richieste')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getPazientiFemmineTotali() {
    return this.http
      .get<number>(this.API_ENDPOINT_COT_SERVICE + '/pazienti-femmine-richieste')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getTotaleRichiestePerStato() {
    return this.http
      .get<RichiestePerStato[]>(this.API_ENDPOINT_COT_SERVICE + '/richieste-group-by-stato-richiesta')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }



}
